import React from 'react'
// import logo from '../../../images/home/100startups-logo.svg';

export default function Refund() {
    const handleEmailClick = () => {
        window.open('https://mail.google.com/mail/?view=cm&fs=1&to=support@surgestartups.com');
    };
    return (
        <div className='w-full h-screen relative overflow-y-scroll p-[20px] md:p-[50px]'>
            {/* <div className='relative z-[10] mx-auto'>
                <img src={logo} alt='logo' />
            </div> */}
            <h1 className='text-[24px] sm:text-[32px] lg:text-[54px] text-[#252525] font-bold text-center'>Refund Policy – Surge Students</h1>
            <h2 className='text-[18px] sm:text-[24px] lg:text-[32px] text-[#252525] font-bold mt-[40px]'>Last Updated: 05-01-2026</h2>
            <div>
                <h2 className='text-[18px] sm:text-[24px] lg:text-[32px] text-[#252525] font-bold mt-[40px]'>Introduction</h2>
                <div className='ml-[50px]'>
                    <p className='text-[12px] sm:text-[16px] lg:text-[24px] text-[#252525] font-medium mt-[20px] z-10 relative'><span className='text-[#34C759]'>•</span> Surge Students operates on a commitment-based monthly model.</p>
                </div>
            </div>
            <div>
                <h2 className='text-[18px] sm:text-[24px] lg:text-[32px] text-[#252525] font-bold mt-[40px]'>Because mentors, schedules and resources are allocated once a student joins:</h2>
                <div className='ml-[50px]'>
                    <p className='text-[12px] sm:text-[16px] lg:text-[24px] text-[#252525] font-medium mt-[20px] z-10 relative'><span className='text-[#34C759]'>•</span> No refunds are provided once mentorship access has been activated for a month.</p>
                    <p className='text-[12px] sm:text-[16px] lg:text-[24px] text-[#252525] font-medium mt-[20px] z-10 relative'><span className='text-[#34C759]'>•</span> If a student makes a duplicate or incorrect payment, it will be reviewed and refunded if verified.</p>
                    <p className='text-[12px] sm:text-[16px] lg:text-[24px] text-[#252525] font-medium mt-[20px] z-10 relative'><span className='text-[#34C759]'>•</span> If a student cancels before their mentorship starts, they may request a refund within 48 hours of payment.</p>
                </div>
            </div>
            <div>
                <h2 className='text-[18px] sm:text-[24px] lg:text-[32px] text-[#252525] font-bold mt-[40px]'>All refund requests must be sent to:</h2>
                <div className='ml-[50px]'>
                    <p className='text-[12px] sm:text-[16px] lg:text-[24px] text-[#252525] font-medium mt-[20px] z-10 relative'>Approved refunds are processed within 7–10 business days to the original payment method.</p>
                    <p className='text-[12px] sm:text-[16px] lg:text-[24px] text-[#252525] font-medium mt-[20px] z-10 relative'>For refund assistance, contact: <span className='text-[#34C759] underline cursor-pointer' onClick={() => { handleEmailClick() }}>support@surgestartups.com</span></p>
                </div>
            </div>
        </div>
    )
}
